/** 微信分享缩略图：固定 App Logo（爬虫不执行 JS，无法按课程/老师动态换图） */
export const SHARE_LOGO_URL = 'https://cdn.group-je.com/og-share.png?v=app'

/** 更新页面分享用 meta（便于浏览器；微信爬虫仍主要读首屏 HTML） */
function upsertMeta(attr, key, content) {
  if (!content) return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

/**
 * @param {{ title?: string, description?: string, url?: string }} opts
 */
export function setShareMeta(opts = {}) {
  const title = (opts.title || '').trim() || 'GoTrustJP - 日本留学考学辅导'
  const description =
    (opts.description || '').trim() ||
    '名师课程、留学资讯一站式服务，打开查看详情并下载 App'
  const image = SHARE_LOGO_URL
  const url = (opts.url || '').trim() || window.location.href

  document.title = title
  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:image', image)
  upsertMeta('property', 'og:url', url)
  upsertMeta('name', 'description', description)
  upsertMeta('itemprop', 'name', title)
  upsertMeta('itemprop', 'description', description)
  upsertMeta('itemprop', 'image', image)
}
